import React, {useCallback} from 'react';
// import styles from './NavToggle.module.scss';
import  './Hamburger.module.scss';
import {useSelector} from "react-redux";

const NavToggle = (props) => {

    let open = props.closeOnly || props.menuOpen;

    const panelData = useSelector(state => state.panelData);

    const getColor = useCallback(()=>{
        let useGrey = false;
        if(panelData.stackOrder.cache === 'active' || panelData.stackOrder.martellus === 'active'){
            useGrey = true
        }
        return useGrey;
    }, [panelData])


    return (
        <div className={`hamburger hamburger--squeeze js-hamburger ${open ? 'is-active' : ''} ${getColor() ? 'dark' : ''}`}>
            <div className="hamburger-box">
                <div className="hamburger-inner"/>
            </div>
        </div>
    )
};

export default NavToggle
